import i18n from "i18n";
import { SelectObject } from "models/SelectObject";

interface DataObject {
  name: string;
  code: number;
}

export const convertToLabelValueObject = (
  dataArray: DataObject[]
): SelectObject[] => {
  return dataArray?.map((dataObj) => {
    return {
      label: dataObj.name,
      value: dataObj.code,
    };
  });
};

export const AddExtraSelectOptions = (
  dataArray: SelectObject[],
  position = "unshift",
  labelName = i18n.t("labelAll"),
  labelValue = 999
) => {
  const newArray = dataArray;
  newArray[position]({
    label: labelName,
    value: labelValue,
  });
  return newArray;
};
